<template>
  <div class="relative bg-white pt-16 pb-16">
    <div class="px-4 md:px-10 mx-auto w-full">
      <div class="flex flex-wrap mt-6">
        <div class="w-full px-4">
          <div class="relative flex flex-col min-w-0 break-words w-full mb-6 shadow-lg rounded bg-white">
            <div class="rounded-t mb-0 px-6 py-3 border-0">
              <div class="flex flex-wrap items-center">
                <div class="relative w-full px-4 max-w-full flex-grow flex-1">
                  <h3 class="font-semibold text-base text-blueGray-700">图片管理</h3>
                </div>
                <div class="relative w-full px-4 max-w-full flex-grow flex-1 text-right">
                  <el-upload
                    name="file"
                    class="upload-picture-entry"
                    drag
                    :action="uploadImgUrl"
                    :headers="uploadHeaders"
                    :show-file-list="false"
                    :data="upload_data"
                    :on-success="handleTopUploadSuccess"
                    :on-error="handleTopUploadError"
                    :before-upload="beforeImgUpload"
                  >
                    <div class="upload-picture-entry-content">
                      <div class="upload-picture-entry-title">拖拽图片到这里，或点击上传</div>
                      <div class="upload-picture-entry-desc">上传后会自动打开配置弹窗</div>
                    </div>
                  </el-upload>
                </div>
              </div>
            </div>
            <div class="block w-full px-6 pb-6">
    <el-tabs v-model="type" @tab-click="handleClick" type="card">
      <el-tab-pane label="经典奖品图" name="prize" v-loading="loading">
        <div class="filter-row">
          <el-radio-group v-model="radioValue" size="default" @change="refreshData" style="margin-right: 20px">
            <el-radio-button v-for="item, index in showOptions" :key="index" :label="item.value">{{ item.name
            }}</el-radio-button>
          </el-radio-group>

          <el-radio-group v-model="radio1Value" size="default" @change="refreshData">
            <el-radio-button v-for="item, index in templateOptions" :key="index" :label="item.value">{{ item.name
            }}</el-radio-button>
          </el-radio-group>
        </div>
        <div class="card-list">
          <el-card v-for="(item, index) in tableData" :key="index" :body-style="{ padding: '0px' }" class="card-item">
            <img :src="getPictureUrl(item)" class="image">
            <div style="padding-top: 8px;">
              <div class="bottom-box">
                <el-button type="" size="default" @click="handleUpdate(item)">
                  <span v-if="!item.is_show">上架</span>
                  <span v-else>下架</span>
                </el-button>
                <el-button type="" size="default" @click="handleMove(item)">移动</el-button>
                <el-button type="" size="default" @click="handleDelete(item)">删除</el-button>
              </div>
            </div>
          </el-card>
          <i></i><i></i><i></i><i></i><i></i><i></i>
        </div>
      </el-tab-pane>
      <el-tab-pane label="头图" name="head" v-loading="loading">
        <div class="filter-row">
          <el-radio-group v-model="radioValue" size="default" @change="refreshData" style="margin-right: 20px">
            <el-radio-button v-for="item, index in showOptions" :key="index" :label="item.value">{{ item.name
            }}</el-radio-button>
          </el-radio-group>
        </div>
        <div class="card-list">
          <el-card v-for="(item, index) in tableData" :key="index" :body-style="{ padding: '0px' }" class="card-item">
            <img :src="getPictureUrl(item)" class="image1">
            <div style="padding-top: 8px;">
              <div class="bottom-box">
                <el-button type="" size="default" @click="handleUpdate(item)">
                  <span v-if="!item.is_show">上架</span>
                  <span v-else>下架</span>
                </el-button>
                <el-button type="" size="default" @click="handleMove(item)">移动</el-button>
                <el-button type="" size="default" @click="handleDelete(item)">删除</el-button>
              </div>
            </div>
          </el-card>
          <i></i><i></i><i></i><i></i><i></i><i></i>
        </div>
      </el-tab-pane>
      <el-tab-pane label="互动抽奖背景图" name="interactive_bgs" v-loading="loading">
        <div class="filter-row">
          <el-radio-group v-model="radioValue" size="default" @change="refreshData" style="margin-right: 20px">
            <el-radio-button v-for="item, index in showOptions" :key="index" :label="item.value">{{ item.name
            }}</el-radio-button>
          </el-radio-group>
        </div>
        <div class="card-list">
          <el-card v-for="(item, index) in tableData" :key="index" :body-style="{ padding: '0px' }" class="card-item">
            <img :src="getPictureUrl(item)" class="image2">
            <div style="padding-top: 8px;">
              <div class="bottom-box">
                <el-button type="" size="default" @click="handleUpdate(item)">
                  <span v-if="radioValue == 0">上架</span>
                  <span v-else>下架</span>
                </el-button>
                <el-button type="" size="default" @click="handleEdit(item)">编辑</el-button>
                <el-button type="" size="default" @click="handleDelete(item)">删除</el-button>
              </div>
            </div>
          </el-card>
          <i></i><i></i><i></i><i></i><i></i><i></i>
        </div>
      </el-tab-pane>
    </el-tabs>

    <el-pagination style="margin-top: 16px; text-align: right" background
      layout="total, sizes, prev, pager, next, jumper" :total="total" :page-sizes="[20, 50, 100]"
      @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="currentPage"
      :page-size="pageSize">
    </el-pagination>
            </div>
          </div>
        </div>
      </div>
    </div>

    <el-dialog :title="title" :close-on-click-modal="false" v-model="templateVisible" width="460px">
      <el-form :model="templateData" :rules="template_rules" ref='template_form' label-width="110px">
        <el-form-item label="图片分组" v-if="type != 'head' && type != 'interactive_bgs'">
          <el-select class="form_value" v-model="templateData.stype" placeholder="请选择">
            <el-option v-for="item in templateOptions" :key="item.value" :label="item.name" :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="排序" prop="sort">
          <el-input-number v-model="templateData.sort" :min="0" placeholder="请输入数字"
            controls-position="right"></el-input-number>
          <span style="margin-left: 10px;color: #999">数字越大越靠前</span>
        </el-form-item>
        <el-form-item label="图片" v-if="sub_type != 'move'">
          <el-upload
            name="file"
            class="picture-drag-uploader"
            drag
            :action="uploadImgUrl"
            :headers="uploadHeaders"
            :show-file-list="false"
            :data="upload_data"
            :on-success="handleImgSuccess"
            :before-upload="beforeImgUpload"
          >
            <div class="picture-upload-content">
              <img v-if="templateData.pic_url" :src="templateData.pic_url" class="picture-upload-preview">
              <template v-else>
                <i class="fas fa-cloud-upload-alt picture-upload-icon"></i>
                <div class="picture-upload-text">拖放图片到这里，或点击上传</div>
              </template>
            </div>
            <template #tip><div class="el-upload__tip">
              <p v-if="type == 'head'">头图 长宽比例为 1:1</p>
              <p v-else-if="type == 'prize'">经典抽奖 奖品图 长宽比例为 2:1</p>
              <p v-else-if="type == 'interactive_bgs'">互动抽奖背景图片三个通用</p>
              <p v-else>互动抽奖 奖品图 长宽比例为 4:3</p>
            </div></template>
          </el-upload>
          <div v-if="show_pic_tip" class="avatar-uploader-tip">请上传图片！</div>
        </el-form-item>
        <template v-if="type == 'interactive_bgs'">
          <el-form-item label="背景色">
            <el-input v-model="templateData.bgcolor" placeholder="请输入颜色值，例如：#FF0000"></el-input>
          </el-form-item>
          <el-form-item label="文字颜色">
            <el-input v-model="templateData.color" placeholder="请输入颜色值，例如：#FF0000"></el-input>
          </el-form-item>
          <el-form-item label="投影颜色">
            <el-input v-model="templateData.shadow" placeholder="请输入颜色值，例如：#FF0000"></el-input>
          </el-form-item>
          <el-form-item label="卡牌图片">
            <el-upload
              name="file"
              class="picture-drag-uploader"
              drag
              :action="uploadImgUrl"
              :headers="uploadHeaders"
              :show-file-list="false"
              :data="upload_data"
              :on-success="handleCardSuccess"
              :before-upload="beforeImgUpload"
            >
              <div class="picture-upload-content">
                <img v-if="templateData.cardimg" :src="templateData.cardimg" class="picture-upload-preview">
                <template v-else>
                  <i class="fas fa-cloud-upload-alt picture-upload-icon"></i>
                  <div class="picture-upload-text">拖放图片到这里，或点击上传</div>
                </template>
              </div>
              <template #tip><div class="el-upload__tip">翻牌抽奖的卡片图片，可以直接用当前的</div></template>
          </el-upload>
          </el-form-item>
        </template>
      </el-form>
      <template #footer><div class="dialog-footer">
        <el-button @click="templateVisible = false">取消</el-button>
        <el-button type="primary" @click="saveTemplate()">确定</el-button>
      </div></template>
    </el-dialog>
  </div>
</template>

<script>

export default {
  name: 'PrizePictureList',
  data() {
    return {
      formInline: {},
      total: 0,
      currentPage: 1,
      pageSize: 20,
      tableData: [],
      loading: false,
      //
      type: 'prize',
      radioValue: 0,
      radio1Value: '',
      typeOptions: [
        { name: '头图', value: 'head' }, // 头图
        { name: '经典奖品图', value: 'prize' }, // 经典 奖品图
      ],
      showOptions: [
        { name: '未上架', value: 0 },
        { name: '已上架', value: 1 },
      ],
      sub_type: 'upload',
      show_pic_tip: false,
      title: '上传图片',
      //
      templateVisible: false,
      templateOptions: [
        { name: '全部', value: '' },
        { name: '锦鲤', value: 2 },
        { name: '卡券', value: 3 },
        { name: '红包', value: 4 },
        { name: '福袋', value: 5 },
        { name: '节日', value: 6 },
        { name: '其他', value: 1 },
      ],
      template_rules: {
        stype: [
          { required: true, message: '图片分组不能为空！', trigger: 'change' },
        ],
        sort: [
          { required: true, message: '排序不能为空！', trigger: 'blur' },
        ],
        pic_url: [
          { required: true, message: '图片不能为空！', trigger: 'change' },
        ]
      },
      templateData: {
        stype: '',
        sort: 0,
      },
      info: null,
      uploadImgUrl: this.$uploadImageUrl,
      uploadHeaders: this.$getUploadHeaders(),
      upload_data: { biz: 'console' },
    }
  },
  mounted() {
    this.queryData();
  },
  methods: {
    refreshData() {
      this.currentPage = 1
      this.queryData()
    },
    queryData() {
      const params = {
        page: this.currentPage,
        page_size: this.pageSize,
        ...this.formInline,
        type: this.type,
        is_show: this.radioValue == 1,
        stype: this.type == 'interactive_bgs' ? 'turntable' : this.radio1Value,
      };

      this.loading = true;
      this.$$getPrizePictureList(
        params,
        (res) => {
          if (res.sta === 0) {
            this.loading = false;
            this.tableData = res.data.list;
            this.total = res.data.total;
          } else {
            this.loading = false;
            this.$message.error(res.msg);
          }
        },
        () => {
          this.loading = false;
          this.$message.error('请求数据失败!');
        },
      );
    },
    handleSizeChange(val) {
      this.currentPage = 1;
      this.pageSize = val;
      this.queryData();
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      this.queryData();
    },
    getPictureUrl(item) {
      return item.pic_url || item.pic || item.url || item.image_url || item.img_url || '';
    },
    handleClick(tab) {
      this.tableData = [];
      this.total = 0;
      this.type = tab.props.name;
      this.radioValue = 0;
      this.radio1Value = '';
      this.currentPage = 1;
      this.queryData();
    },
    handleUpload(picUrl = '') {
      this.sub_type = 'upload';
      this.title = '上传图片';
      if (this.type == 'interactive_bgs') {
        this.templateData = {
          stype: 'turntable',
          sort: 0,
          pic_url: picUrl,
          bgcolor: '',
          color: '',
          shadow: '',
          cardimg: 'https://cdn.zhinizhushou.com/material/20250206/a6000aa2e45911efa1b3acde48001122.png',
          winbg: 'https://cdn.zhinizhushou.com/material/20250206/706649a0e45511efa1b3acde48001122.png',
          templatepic: 'https://cdn.zhinizhushou.com/material/2024-12-06/a5fe9e6a7d580913047da79a4e6065ec.png'
        }
      } else {
        this.templateData = {
          // type: '', // head / prize
          stype: '',
          sort: 0,
          pic_url: picUrl,
        };
      }

      this.show_pic_tip = false;
      this.templateVisible = true;
      this.$nextTick(() => {
        this.$refs['template_form'].resetFields();
        if (picUrl) {
          this.templateData.pic_url = picUrl;
        }
      })
    },
    handleTopUploadSuccess(res) {
      if (res.sta == 0) {
        this.handleUpload(res.data.url);
      } else {
        this.$message.error(res.msg || '上传图片失败!');
      }
    },
    handleTopUploadError() {
      this.$message.error('上传图片失败!');
    },
    handleImgSuccess(res) {
      if (res.sta == 0) {
        this.templateData.pic_url = res.data.url;
        this.show_pic_tip = false;
      }
    },
    handleCardSuccess(res) {
      if (res.sta == 0) {
        this.templateData.cardimg = res.data.url
      }
    },
    beforeImgUpload(file) {
      const isLt2M = file.size / 1024 / 1024 < 2;
      if (!isLt2M) {
        this.$message.error('上传图片大小不能超过 2MB!');
      }
      return isLt2M;
    },
    saveTemplate() {
      const self = this;
      this.$refs['template_form'].validate((valid) => {
        if (valid) {
          if (self.sub_type == 'upload') {
            if (!self.templateData.pic_url) {
              self.show_pic_tip = true;
              return;
            }
            if (self.type == 'interactive_bgs') {
              if (!self.templateData.bgcolor) {
                self.$message.error('请输入背景色')
                return
              }
              if (!self.templateData.color) {
                self.$message.error('请输入文字颜色')
                return
              }
              if (!self.templateData.shadow) {
                self.$message.error('请输入阴影颜色')
                return
              }
              if (!self.templateData.cardimg) {
                self.$message.error('请上传卡牌图片')
                return
              }
            }
          }

          templateFunc();
        }
      });
      function templateFunc() {
        console.log('sub_type', self.sub_type);

        if (self.sub_type == 'upload') { // 上传 新建
          let data = null
          if (self.type == 'interactive_bgs') {
            data = {
              type: self.type,
              stype: self.templateData.stype,
              sort: self.templateData.sort || 0,
              pic_url: self.templateData.pic_url,
              bgcolor: self.templateData.bgcolor,
              color: self.templateData.color,
              shadow: self.templateData.shadow,
              cardimg: self.templateData.cardimg,
              winbg: self.templateData.winbg,
              templatepic: self.templateData.templatepic
            }
          } else {
            data = {
              type: self.type,
              stype: self.templateData.stype,
              sort: self.templateData.sort || 0,
              pic_url: self.templateData.pic_url,
            };
          }
          self.$$createPrizePicture(data, (data) => {
            if (data.sta != 0) {
              self.$message.error({ message: data.msg ? data.msg : '上传图片失败!' });
            } else {
              self.$message({ type: 'success', message: '上传图片成功!' });
              self.templateVisible = false;
              self.queryData();
            }
          });
        } else if (self.sub_type == 'move') { // 移动 修改
          const data = {
            id: self.info._id,
            stype: self.templateData.stype,
            sort: self.templateData.sort || 0,
          };
          self.$$updatePrizePicture(data, (data) => {
            if (data.sta != 0) {
              self.$message.error({ message: data.msg ? data.msg : '移动图片失败!' });
            } else {
              self.$message({ type: 'success', message: '移动图片成功!' });
              self.templateVisible = false;
              self.queryData();
            }
          });
        } else if (self.sub_type == 'edit') {
          const data = {
            id: self.info._id,
            ...self.templateData
          }
          self.$$updatePrizePicture(data, (data) => {
            if (data.sta != 0) {
              self.$message.error({ message: data.msg ? data.msg : '编辑失败!' });
            } else {
              self.$message({ type: 'success', message: '编辑成功!' });
              self.templateVisible = false;
              self.queryData();
            }
          });
        }
      }
    },
    handleUpdate(row) {
      const self = this;
      this.$confirm(`确定${self.radioValue == 0 ? '上架' : '下架'}此图片？`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          let params = { id: row._id }
          if (self.type == 'interactive_bgs') {
            params.type = 'interactive_bgs'
          }
          self.$$showPrizePicture(params, (data) => {
            if (data.sta != 0) {
              self.$message.error({ message: data.msg ? data.msg : '上架图片失败!' });
            } else {
              self.$message({ type: 'success', message: '上架图片成功!' });
              self.queryData();
            }
          });
        })
        .catch(() => { });
    },
    handleMove(row) {
      this.sub_type = 'move';
      this.title = '移动图片';
      this.info = row;
      this.show_pic_tip = false;
      this.templateVisible = true;
      this.$nextTick(() => {
        this.$refs['template_form'].resetFields();
        this.templateData = {
          stype: row.stype,
          sort: row.sort || 0,
        }
      })
    },
    handleEdit(row) {
      this.sub_type = 'edit'
      this.info = row
      this.templateVisible = true
      this.$nextTick(() => {
        this.$refs['template_form'].resetFields();
        this.templateData = {
          type: 'interactive_bgs',
          stype: 'turntable',
          sort: row.sort || 0,
          pic_url: row.pic_url,
          bgcolor: row.bgcolor,
          color: row.color,
          shadow: row.shadow,
          cardimg: row.cardimg,
          winbg: 'https://cdn.zhinizhushou.com/material/20250206/706649a0e45511efa1b3acde48001122.png',
          templatepic: 'https://cdn.zhinizhushou.com/material/2024-12-06/a5fe9e6a7d580913047da79a4e6065ec.png'
        }
      })
    },
    handleDelete(row) {
      const self = this;
      this.$confirm('确定删除此图片？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          const params = {
            data: {
              id: row._id
            }
          }
          if (self.type == 'interactive_bgs') {
            params.data.type = 'interactive_bgs'
          }
          self.$$deletePrizePicture(params, (data) => {
            if (data.sta != 0) {
              self.$message.error({ message: data.msg ? data.msg : '删除图片失败!' });
            } else {
              self.$message({ type: 'success', message: '删除图片成功!' });
              self.queryData();
            }
          });
        })
        .catch(() => { });
    },
  }
}
</script>

<style scoped>
.card-list {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(220px, 1fr));
  gap: 16px;
  margin-top: 16px;

}

.card-list > i {
  display: none;
}

.card-item {
  width: 100%;
  margin-bottom: 0;
  padding: 14px;
  box-sizing: border-box;
}

.card-item .image {
  width: 100%;
  aspect-ratio: 1 / 1;
  height: auto;
  display: block;
  object-fit: contain;
  background: #f8fafc;
  border-radius: 4px;
}

.card-item .image1 {
  width: 100%;
  aspect-ratio: 1 / 1;
  height: auto;
  display: block;
  object-fit: contain;
  background: #f8fafc;
  border-radius: 4px;
}

.card-item .image2 {
  width: 100%;
  aspect-ratio: 4 / 3;
  height: auto;
  display: block;
  object-fit: contain;
  background: #f8fafc;
  border-radius: 4px;
}

.card-item .bottom-box {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;
}

.filter-row {
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
  margin-top: 16px;
  align-items: center;
}

.upload-picture-entry {
  width: 260px;
  margin-left: auto;
}

.upload-picture-entry :deep(.el-upload) {
  width: 100%;
}

.upload-picture-entry :deep(.el-upload-dragger) {
  width: 100%;
  min-height: 64px;
  padding: 0;
  border-radius: 10px;
  border-color: #86efac;
  background: linear-gradient(135deg, #f0fdf4 0%, #ecfdf5 100%);
  display: flex;
  align-items: center;
  justify-content: center;
}

.upload-picture-entry-content {
  min-height: 62px;
  padding: 8px 12px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 4px;
  text-align: center;
}

.upload-picture-entry-title {
  font-size: 13px;
  line-height: 1.2;
  font-weight: 600;
  color: #047857;
}

.upload-picture-entry-desc {
  font-size: 11px;
  line-height: 1.2;
  color: #6b7280;
}

.picture-drag-uploader {
  width: 260px;
}

.picture-drag-uploader :deep(.el-upload) {
  width: 100%;
}

.picture-drag-uploader :deep(.el-upload-dragger) {
  width: 260px;
  height: 180px;
  padding: 0;
  display: flex;
  align-items: center;
  justify-content: center;
}

.picture-upload-content {
  width: 100%;
  height: 100%;
  min-height: 178px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  color: #6b7280;
}

.picture-upload-preview {
  max-width: 100%;
  max-height: 176px;
  object-fit: contain;
}

.picture-upload-icon {
  font-size: 32px;
  color: #10b981;
  margin-bottom: 10px;
}

.picture-upload-text {
  font-size: 14px;
}

.avatar-uploader-tip {
  color: #F56C6C;
  font-size: 12px;
  position: absolute;
  left: 0;
  bottom: 20px;
}
</style>
